import type { ReactElement } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ROUTE_HOME } from '../../routes/routes.constants';

/**
 * Общая страница ошибки (контент и причины задаются в следующих задачах).
 *
 * @returns {ReactElement}
 */
export function SomethingWentWrong(): ReactElement {
  const location = useLocation();
  const homeTo = { pathname: ROUTE_HOME, search: location.search, hash: location.hash };

  return (
    <main className='app-shell app-shell--error'>
      <h1 className='app-shell__title'>Что-то пошло не так</h1>
      <p className='app-shell__hint'>Попробуйте вернуться на главную или повторить действие позже.</p>
      <p>
        <Link to={homeTo}>На главную</Link>
      </p>
    </main>
  );
}
